import React, {useRef, useState} from 'react';
import cx from 'classnames';
import {Button, Flex, PriorityIcon} from '@priority-software/priority-style-react';
import {isRTL} from '../../../../Localization';
import {Form} from '../../../../stores/Form/Form';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';
import {createDataTestId} from '../../../../utils/dataTestId';
import texts from '../../texts';
import styles from './styles.module.scss';

type Props = {
    disablePrev: boolean;
    disableNext: boolean;
    prevBtnTooltipText: string;
    nextBtnTooltipText: string;
    onNextClick: () => void;
    onPrevClick: () => void;
    current: string;
    total: string;
    form: Form;
};

const tooltipDelay = 1000;

export const Pagination = (props: Props) => {
    const {
        disableNext,
        disablePrev,
        prevBtnTooltipText,
        nextBtnTooltipText,
        onNextClick,
        onPrevClick,
        current,
        total
    } = props;

    const [locked, setLocked] = useState(false);
    const anchorRef = useRef();

    const handleButtonClick = async (actionFunc: () => void) => {
        setLocked(true);
        await actionFunc();
        setLocked(false);
    };

    const btnClasses = cx(styles.btn, {[styles.lockedBtn]: locked});

    return (
        <Flex
            componentClasses={styles.pagination}
            inline
            {...createDataTestId('pagination-section-container', true)}
        >
            {
                <Flex inline>
                    <ModernTooltip
                        position="top"
                        tooltip={isRTL() ? nextBtnTooltipText : prevBtnTooltipText}
                        delay={tooltipDelay}
                    >
                        <Button
                            roundedCorners={false}
                            componentClasses={btnClasses}
                            disabled={disablePrev}
                            onClick={() => handleButtonClick(onPrevClick)}
                            icon={isRTL() ? PriorityIcon.arrowRight : PriorityIcon.arrowLeft}
                            skin="text"
                        />
                    </ModernTooltip>

                    <ModernTooltip
                        position="top"
                        tooltip={isRTL() ? prevBtnTooltipText : nextBtnTooltipText}
                        delay={tooltipDelay}
                    >
                        <Button
                            roundedCorners={false}
                            componentClasses={btnClasses}
                            skin="text"
                            disabled={disableNext}
                            icon={isRTL() ? PriorityIcon.arrowLeft : PriorityIcon.arrowRight}
                            onClick={() => handleButtonClick(onNextClick)}
                        />
                    </ModernTooltip>
                </Flex>
            }

            <div
                className={styles.dataLabel}
                {...createDataTestId('pagination-data-section', false)}
            >
                <span className={styles.item}>{current}</span>{' '}
                <span className={styles.item}>{texts.of_delimeter}</span>{' '}
                <span ref={anchorRef}>
                    <span>{total}</span>
                </span>
            </div>
        </Flex>
    );
};
